export default {"src":"/_next/static/media/ciclogo.becc3b92.svg","height":44,"width":140,"blurWidth":0,"blurHeight":0};